import { render } from "./CompleteTestModal.vue?vue&type=template&id=77990736&scoped=true"
import script from "./CompleteTestModal.vue?vue&type=script&lang=js"
export * from "./CompleteTestModal.vue?vue&type=script&lang=js"

import "./CompleteTestModal.vue?vue&type=style&index=0&id=77990736&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77990736"]])

export default __exports__